module.exports = __webpack_public_path__ + "roboto-regular-webfont.d9c5b5dc45c1e075c119.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-regular-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-regular-webfont.woff
// module chunks = styles